module.exports = __webpack_public_path__ + "static/media/SalleConference11Thumb.ae724b60.jpg";